import { useEffect, useRef, useState } from 'react'

export const Spinner = () => <div className="spinner" role="status" aria-label="Cargando" />

export const Empty = ({ title, children, action }) => (
  <div className="empty">
    <h3>{title}</h3>
    <p>{children}</p>
    {action && <div style={{ marginTop: 16 }}>{action}</div>}
  </div>
)

/** Los cuatro valores del enum de Dokploy, verificados en v0·S6. */
const LABEL = { done: 'Correcto', running: 'En curso', error: 'Fallido', cancelled: 'Cancelado' }
export const Status = ({ status }) => {
  const cls = ['done', 'running', 'error'].includes(status) ? status : ''
  return (
    <span className={`badge ${cls}`}>
      <span className="dot" />
      {LABEL[status] ?? 'Sin desplegar'}
    </span>
  )
}

export const Stat = ({ label, value, sub }) => (
  <div className="stat">
    <div className="stat-label">{label}</div>
    <div className="stat-value">{value}</div>
    {sub && <div className="stat-sub">{sub}</div>}
  </div>
)

/** Desplegable con cierre por clic fuera y por Escape. */
export function Menu({ trigger, children, align = 'left' }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDown = (e) => { if (!ref.current?.contains(e.target)) setOpen(false) }
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', onDown)
    document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey) }
  }, [open])

  return (
    <div className="menu" ref={ref}>
      <button className="menu-trigger" aria-expanded={open} aria-haspopup="menu"
              onClick={() => setOpen((v) => !v)}>
        {trigger}
      </button>
      {open && (
        <div className={`menu-panel ${align === 'right' ? 'right' : ''}`} role="menu"
             onClick={() => setOpen(false)}>
          {children}
        </div>
      )}
    </div>
  )
}

export function Avatar({ src, name, email, lg }) {
  const [failed, setFailed] = useState(false)
  const initials = (name ?? email ?? '?').trim().slice(0, 1).toUpperCase()
  if (!src || failed) {
    return <div className={`avatar avatar-fallback ${lg ? 'lg' : ''}`}>{initials}</div>
  }
  return <img className={`avatar ${lg ? 'lg' : ''}`} src={src} alt="" onError={() => setFailed(true)} />
}

export function relTime(iso) {
  if (!iso) return '—'
  const diff = (new Date(iso) - Date.now()) / 1000
  const rtf = new Intl.RelativeTimeFormat('es', { numeric: 'auto' })
  for (const [unit, secs] of [['day', 86400], ['hour', 3600], ['minute', 60]]) {
    if (Math.abs(diff) >= secs) return rtf.format(Math.round(diff / secs), unit)
  }
  return rtf.format(Math.round(diff), 'second')
}

export const fmtNum = (n) => (n == null ? '—' : new Intl.NumberFormat('es').format(n))
